// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test_title[data-v-68db3d43]{font-weight:bolder;font-size:14px;color:#fff;line-height:24px}.reason[data-v-68db3d43]{margin-left:10px}.reason[data-v-68db3d43],.row_click[data-v-68db3d43],.row_title[data-v-68db3d43]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
